import React, {
  useEffect, useState
} from "react";
import axios from "../../../utills/api";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Spinner,
  CardHeader
} from "reactstrap";

import RevenueCard from "./RevenueCard";
import RevenueSummaryTable from "./RevenueSummaryTable";
import RevenueFilters from "./RevenueFilters";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import RevenueTrendChart
  from "./Components/RevenueTrendChart";

import RevenueSourcePie
  from "./Components/RevenueSourcePie";

import PaymentMethodChart
  from "./Components/PaymentMethodChart";

import BookingSourceChart
  from "./Components/BookingSourceChart";

import TopRevenueRooms
  from "./Components/TopRevenueRooms";

import RoomTypeRevenueChart
  from "./Components/RoomTypeRevenueChart";

import OutstandingBookings
  from "./Components/OutstandingBookings";

const RevenueDashboard = () => {
  const [loading, setLoading] =
    useState(true);
  const [summary, setSummary] =
    useState({});
  const [filter, setFilter] =
    useState("month");
  const fetchRevenue =
    async () => {
      try {
        setLoading(true);
        const res =
          await axios.get(
            `/revenue/summary?range=${filter}`
          );
        setSummary(
          res.data.summary
        );
      }
      catch (err) {
        console.error(err);
      }
      finally {
        setLoading(false);
      }
    };
  useEffect(() => {
    fetchRevenue();
  }, [filter]);
  if (loading) {
    return (
      <div className="text-center p-5">
        <Spinner />
      </div>
    );

  }

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Revenue Management" pageTitle="Revenue" />
        <Row>
          <Col md="3">
            <RevenueCard
              title="Total Revenue"
              value={summary.totalRevenue}
              icon="bx bx-wallet"
              color="#0d6efd"
              bgColor="rgba(13,110,253,.12)"
            />
          </Col>

          <Col md="3">
            <RevenueCard
              title="Room Revenue"
              value={summary.roomRevenue}
              icon="bx bx-building-house"
              color="#198754"
              bgColor="rgba(25,135,84,.12)"
            />
          </Col>

          <Col md="3">
            <RevenueCard
              title="Food Revenue"
              value={summary.foodRevenue}
              icon="bx bx-dish"
              color="#fd7e14"
              bgColor="rgba(253,126,20,.12)"
            />
          </Col>

          <Col md="3">
            <RevenueCard
              title="Spa Revenue"
              value={summary.spaRevenue}
              icon="bx bx-spa"
              color="#6f42c1"
              bgColor="rgba(111,66,193,.12)"
            />
          </Col>
        </Row>

        <Row className="mt-3">
          <Col md="3">
            <RevenueCard
              title="Restaurant Revenue"
              value={summary.restaurantRevenue}
              icon="bx bx-restaurant"
              color="#20c997"
              bgColor="rgba(32,201,151,.12)"
            />
          </Col>

          <Col md="3">
            <RevenueCard
              title="Tax Collected"
              value={summary.totalTax}
              icon="bx bx-receipt"
              color="#ffc107"
              bgColor="rgba(255,193,7,.15)"
            />
          </Col>

          <Col md="3">
            <RevenueCard
              title="Outstanding"
              value={summary.outstanding}
              icon="bx bx-error-circle"
              color="#dc3545"
              bgColor="rgba(220,53,69,.12)"
            />
          </Col>

          <Col md="3">
            <RevenueCard
              title="Net Revenue"
              value={summary.netRevenue}
              icon="bx bx-line-chart"
              color="#0dcaf0"
              bgColor="rgba(13,202,240,.12)"
            />
          </Col>
        </Row>
        <Row className="mt-4">
          <Col lg="8">
            <RevenueTrendChart
              data={
                summary.revenueTrend || []
              }
            />
          </Col>
          <Col lg="4">
            <RevenueSourcePie
              summary={summary}
            />
          </Col>
        </Row>
        <Row className="mt-4">
          <Col lg="6">
            <PaymentMethodChart
              paymentSummary={
                summary.paymentSummary
              }
            />
          </Col>
          <Col lg="6">
            <TopRevenueRooms
              rooms={
                summary.topRooms
              }
            />
          </Col>
        </Row>
        <Row className="mt-4">
          <Col lg="6">
            <RoomTypeRevenueChart
              roomTypes={
                summary.roomTypeRevenue
              }
            />
          </Col>
          <Col lg="6">
            <BookingSourceChart
              bookingSources={
                summary.bookingSources
              }
            />
          </Col>
        </Row>
        <Row className="mt-4">
          <Col lg="12">
            <OutstandingBookings
              bookings={
                summary.outstandingBookings
              }
            />
          </Col>
        </Row>
        <RevenueSummaryTable
          summary={summary}
        />
      </Container>
    </div>


  );
};
export default RevenueDashboard;